export const RESTRICTED_ACCESS_EMAILS = [
  "redditpromotions1@gmail.com",
  "redditpromotions2@gmail.com",
  "chris1564@inbox.lv",
  "saadkareem2481@gmail.com",
  "mapsjohn89@gmail.com",
] as const;

export const isRestrictedAccessEmail = (email?: string | null): boolean => {
  if (!email) return false;
  const normalizedEmail = email.trim().toLowerCase();
  return (RESTRICTED_ACCESS_EMAILS as readonly string[]).includes(normalizedEmail);
};

